<template>
    <div>
        <div class="row" style="margin: 20px 0">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <h1 class="text-primary">Szervízmunkák kezelése</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-3">
                <div class="row">
                    <div class="col-lg-6">
                        <button type="submit" class="btn btn-block btn-sm btn-primary" @click="navigate('NewWorksheet')">
                            Új szervízmunka
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button type="submit" class="btn btn-block btn-sm btn-primary" @click="$router.back()">
                            Vissza
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="row justify-content-end">
                    <div class="col-lg-4">
                        <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="edit" v-model="showDoneState">
                            <label class="form-check-label" for="edit">Kész munkalapok megjelenítése</label>
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="form-group" stlye="inline-block">
                            <label class="sr-only" for="filter">Szűrő</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <i class="fa fa-search"></i>
                                    </div>
                                </div>
                                <input
                                    id="filter"
                                    type="filter"
                                    class="form-control form-control-sm"
                                    placeholder="Szűrő"
                                    v-model="filter"
                                    @keypress.enter="getWorksheetList"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <button type="submit" @click="getWorksheetList" class="btn btn-block btn-sm btn-primary">
                            Szűrés
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <table class="table table-striped table-sm table-hover">
                    <thead class="bg-primary text-white">
                    <tr>
                        <th scope="col" @click="odOrder('id')">
                            ID
                            <span v-if="renderOrderMarker('id') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('id') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('time')">
                            Dátum
                            <span v-if="renderOrderMarker('time') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('time') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('status')">
                            Státusz
                            <span v-if="renderOrderMarker('status') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('status') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('client')">
                            Megrendelő
                            <span v-if="renderOrderMarker('client') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('client') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('colors_number')">
                            Sorozatszám
                            <span v-if="renderOrderMarker('colors_number') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('colors_number') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('device_type')">
                            Típus
                            <span v-if="renderOrderMarker('device_type') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('device_type') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('device_type')">
                            Típus
                            <span v-if="renderOrderMarker('device_type') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('device_type') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('client_phone')">
                            Telefonszám
                            <span v-if="renderOrderMarker('client_phone') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('client_phone') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col" @click="odOrder('user')">
                            Módosító
                            <span v-if="renderOrderMarker('user') === 'ASC'">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span v-if="renderOrderMarker('user') === 'DESC'">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="sheet in sheets">
                        <th scope="row">{{sheet.id}}</th>
                        <td>{{formattedDate(sheet.time)}}</td>
                        <td :style="addStatusColor(sheet.status)">{{sheet.status}}</td>
                        <td>{{sheet.client}}</td>
                        <td>{{sheet.colors_number}}</td>
                        <td>{{sheet.device_type}}</td>
                        <td>{{sheet.client_phone}}</td>
                        <td>{{sheet.user}}</td>
                        <td>
                            <button type="submit" class="btn btn-sm btn-primary" @click="navigate('EditWorksheet', {id: sheet.id})">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="row" v-if="sheets.length == 0">
                    <div class="col-lg-12 text-center h5">
                        Nincs megjeleníthető szervízlap.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'worksheets',
        data() {
            return {
                filter: '',
                sheets: [],
                order: {
                    column: 'id',
                    direction: 'DESC'
                },
                showDoneState: true
            }
        },
        methods: {
            formattedDate(dateString){
                let date = new Date(dateString);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();

                if(month < 10){
                    month = '0' + month;
                }
                if(day < 10){
                    day = '0' + day;
                }

                return `${year}. ${month}. ${day}.`;
            },
            getWorksheetList(){
                this.$store.dispatch('WorksheetModul/getWorksheetList', {
                    filter: this.filter,
                    order: this.order,
                    showDone: this.showDoneState,
                    result: (res)=> {
                        this.sheets = res.data.worksheetList;
                    }
                });
            },
            navigate(name, params = null){
                this.$router.push({
                    name,
                    params
                });
            },
            odOrder(column){
                if(column !== this.order.column){
                    this.order.column = column;
                    this.order.direction = 'ASC';
                } else {
                    switch(this.order.direction){
                        case 'ASC':
                            this.order.direction = 'DESC';
                            break;
                        case 'DESC':
                            this.order = {
                                column: null,
                                direction: null
                            }
                    }
                }

                this.getWorksheetList();
            },
            renderOrderMarker(column){
                if(column === this.order.column){
                    return this.order.direction;
                }
            },
            addStatusColor(status){
                if(status.toLowerCase() === 'kész'){
                    return {
                        color: "#00cc00"
                    };
                } else if(status.toLowerCase() === 'behozták'){
                    return {
                        color: "#e50000"
                    };
                }
            }
        },
        mounted(){
            this.getWorksheetList();
        }
    }
</script>

<style scoped>
    th{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Worksheets.vue